import React from 'react';
import {action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import {CheckoutInputElement} from '../inputs/checkoutInputs';
import ModalSimple from '../../../global/modal-simple';
import {hideAllModals, Portal} from '../../../util';

@observer
class ModalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        makeObservable(this);
    }

    @action
    save = async () => {
        store.uiCheckout.isLoadingEstimated = true;
        const success = await checkout('get-est-postal');
        store.uiCheckout.isLoadingEstimated = false;
        try {
            store.checkoutRefreshCS();
        } catch {
            const x = 1;
        }
        hideAllModals();
    };

    render() {
        return (
            <ModalSimple
                id="modal-shipping-est-postal"
                title="ESTIMATE SHIPPING AND TAX"
                saveAndClose={this.save}
                closeButtonText={'Save & Estimate'}
                closeButtonClass={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
            >
                <div>
                    <div className="mb-2">Ship to the following postal code</div>
                    <CheckoutInputElement
                        floating={true}
                        ab={store.checkout.ab}
                        o={store.checkout.ship.addr.postalCode}
                        idSuffix="modal"
                        ariaLabel="Shipping Postal Code"
                        type="text"
                        required={true}
                    />
                </div>
            </ModalSimple>
        );
    }
}
export default ModalInfo;
